import {MouseEventHandler} from "react";
import {useFormContext} from "react-hook-form";

import {Button} from "@/components/button/Button.tsx";
import {FormLabel} from "@/components/form/FormLabel.tsx";
import {Input} from "@/components/input/Input.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

interface Props extends FieldProps {
  btnTitle: string;
  bntOnClick: MouseEventHandler<HTMLButtonElement>;
  variant?: "default" | "split";
}

export const TextWithButton = ({
  className,
  name,
  label,
  helpText,
  btnTitle,
  bntOnClick,
  required,
  variant = "default",
}: Props) => {
  const {
    register,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  return (
    <div className={className}>
      <FormLabel helpText={helpText} forId={name} required={required}>
        {label}
      </FormLabel>
      {variant === "default" ? (
        <div className="input-group">
          <Input id={name} {...register(name, {required: required})} />
          <Button size={"bsInput"} style={{zIndex: "auto"}} onClick={bntOnClick}>
            {btnTitle}
          </Button>
        </div>
      ) : (
        <div className="d-flex gap-3 flex-column flex-sm-row">
          <Input id={name} {...register(name, {required: required})} />
          <div>
            <Button onClick={bntOnClick}>{btnTitle}</Button>
          </div>
        </div>
      )}
      {fieldError && <div className="invalid-feedback d-block">{fieldError.toString()}</div>}
    </div>
  );
};
